var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddInput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0917969 0.881406C0.0917969 0.496285 0.404 0.184082 0.789121 0.184082H17.5249C17.91 0.184082 18.2222 0.496285 18.2222 0.881406V12.7359C18.2222 13.1058 18.0753 13.4605 17.8137 13.7221C17.5522 13.9836 17.1975 14.1306 16.8276 14.1306H1.48645C1.11656 14.1306 0.761828 13.9836 0.50028 13.7221C0.238733 13.4605 0.0917969 13.1058 0.0917969 12.7359V0.881406ZM1.48645 1.57873V12.7359H16.8276V1.57873H1.48645Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0917969 5.06549C0.0917969 4.68037 0.404 4.36816 0.789121 4.36816H17.5249C17.91 4.36816 18.2222 4.68037 18.2222 5.06549C18.2222 5.45061 17.91 5.76281 17.5249 5.76281H0.789121C0.404 5.76281 0.0917969 5.45061 0.0917969 5.06549Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0917969 9.24908C0.0917969 8.86396 0.404 8.55176 0.789121 8.55176H17.5249C17.91 8.55176 18.2222 8.86396 18.2222 9.24908C18.2222 9.6342 17.91 9.94641 17.5249 9.94641H0.789121C0.404 9.94641 0.0917969 9.6342 0.0917969 9.24908Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66998 4.36816C6.0551 4.36816 6.36731 4.68037 6.36731 5.06549V13.4334C6.36731 13.8185 6.0551 14.1307 5.66998 14.1307C5.28486 14.1307 4.97266 13.8185 4.97266 13.4334V5.06549C4.97266 4.68037 5.28486 4.36816 5.66998 4.36816Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInput);
export default __webpack_public_path__ + "static/media/add_input.681449f3.svg";
export { ForwardRef as ReactComponent };